import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TK2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TK2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4V19H22V4H2Z"
          fill="#2E42A5"
        />
        <mask
          id="mask0_1813_960"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="2"
          y="4"
          width="20"
          height="15"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 4V19H22V4H2Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_960)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.05905 10.2896L3.50558 10.6321L3.72045 10.0572L3.25 9.6219H3.82062L4.05905 9L4.241 9.6219H4.8125L4.40063 10.0572L4.60228 10.6321L4.05905 10.2896Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.55905 7.78962L6.00558 8.1321L6.22045 7.55716L5.75 7.1219H6.32062L6.55905 6.5L6.741 7.1219H7.3125L6.90063 7.55716L7.10228 8.1321L6.55905 7.78962Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.05905 10.2896L8.50558 10.6321L8.72045 10.0572L8.25 9.6219H8.82062L9.05905 9L9.241 9.6219H9.8125L9.40063 10.0572L9.60228 10.6321L9.05905 10.2896Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.55905 12.7896L6.00558 13.1321L6.22045 12.5572L5.75 12.1219H6.32062L6.55905 11.5L6.741 12.1219H7.3125L6.90063 12.5572L7.10228 13.1321L6.55905 12.7896Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5263 7.41455C14.9742 8.67528 6.58838 14.3409 6.58838 14.3409H20.5578C20.4183 14.3097 20.2882 14.2838 20.1654 14.2593C19.14 14.0551 18.6338 13.9543 17.5263 11.7483C16.2864 9.27822 17.5263 7.41455 17.5263 7.41455ZM6.13487 15.2283L5.94385 15.7032L6.13487 16.2251L20.3559 16.5001L20.7501 15.7752L20.3559 15.2534L6.13487 15.2283Z"
            fill="#FECA00"
          />
        </g>
      </svg>
    </svg>
  );
};

export default TK2424Icon;
